/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const FormikSideEffect = ({
  children,
  effect = () => {},
  dependencies = [],
}) => {
  useEffect(() => {
    const cleanup = effect(...dependencies);
    return typeof cleanup === "function" ? cleanup : undefined;
  }, dependencies);
  return <>{children}</>;
};

export default FormikSideEffect;
